/**
 *  @internal Used to iterate over an Array his members, with the ability to break if
 *  needed - by returning false in the callback.
 */
export default function forEach(items, cb, thisArg) {
    if (!Array.isArray(items)) {
        throw new TypeError(`ForEach util: provided items is not an Array: ${items}`);
    }
    items.every((item, index) => {
        return false !== cb.call(thisArg, item, index, items);
    });
}
//# sourceMappingURL=forEach.js.map